import { useState } from "react";
import PaymentLayout from "../layouts/PaymentLinkLayouts";
import CustomerDetailForm from "./CustomerDetailForm";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import formatCurrency from "../../utils/numberFormatter";
import validateCustomerData from "../utils/validateCustomerData";
import darkenColor from "../utils/darkenColor"; // ✅ Import darkenColor terpisah

const PaymentDetail = ({
  merchant_name,
  account_name,
  title,
  total_amount,
  reffNo,
  include_constumer_detail,
  status,
  payment_url,
  description,
  items,
  uneditable,
}) => {
  const navigate = useNavigate();
  const customer = useSelector((state) => state.customer);
  const { secondary_color, secondary_text_color, card_title } = useSelector((state) => state.style); // ⭐ Ambil secondary color & card_title
  const [errors, setErrors] = useState({});

  const handleNext = () => {
    const validationErrors = validateCustomerData(customer);
    if (include_constumer_detail && (Object.keys(validationErrors).length > 0)) {
      setErrors(validationErrors);
    } else {
      navigate(`/method/${reffNo}`);
    }
  };

  const [integerPart] = formatCurrency(total_amount).split(",");

  // Check if items exist and not empty
  const hasItems = items && Array.isArray(items) && items.length > 0;

  return (
    <PaymentLayout title={card_title || merchant_name}>
      <div>
        <p className="text-gray-600 text-lg">{title}</p>
        <h2 className="text-5xl font-bold mt-2">
          <span>{integerPart}</span>
        </h2>
        <p className="text-gray-500 mt-2">ID {reffNo}</p>
      </div>

      <div className="border-t border-gray-200 pt-4">
        <h3 className="text-2xl font-bold mb-4">Payment Detail</h3>
        <div className="grid gap-1">
          <div>
            <span className="text-sm text-gray-500">To</span>
            <div className="text-base font-medium">
              {merchant_name} [{account_name}]
            </div>
          </div>
          
          {/* Items Section */}
          {hasItems && (
            <div className="mt-3">
              <span className="text-sm text-gray-500 font-semibold">Items</span>
              <div className="mt-2 space-y-2">
                {items.map((item, index) => (
                  <div 
                    key={index} 
                    className="flex justify-between items-start py-2 border-b border-gray-100 last:border-0"
                  >
                    <div className="flex-1">
                      <p className="text-base font-medium text-gray-800">
                        {item.name}
                      </p>
                      <p className="text-sm text-gray-500">
                        {item.quantity} × {formatCurrency(item.unit_price).split(",")[0]}
                      </p>
                    </div>
                    <div className="text-base font-semibold text-gray-900">
                      {formatCurrency(item.subtotal).split(",")[0]}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mt-3 pt-2 border-t border-gray-200">
            <span className="text-sm text-gray-500">Total Amount</span>
            <div className="text-lg font-bold text-gray-900">
              <span>{integerPart}</span>
            </div>
          </div>
        </div>
      </div>

      {include_constumer_detail && (
        <div className="border-t border-gray-200 pt-4">
          <h3 className="text-2xl font-bold mb-4">Customer Detail</h3>
          <CustomerDetailForm setErrors={setErrors} uneditable={uneditable} />
          {Object.keys(errors).length > 0 && (
            <div className="text-red-500 text-sm mt-2">
              {Object.values(errors).map((error, index) => (
                <p key={index}>{error}</p>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ⭐ Button dengan dynamic secondary color */}
      <button
        onClick={handleNext}
        className="w-full py-4 px-6 rounded-md text-xl font-medium transition-colors text-white"
        style={{ 
          backgroundColor: secondary_color,
          color: secondary_text_color
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = darkenColor(secondary_color, 15);
          e.target.style.color = darkenColor(secondary_text_color, 15);
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = secondary_color;
          e.target.style.color = secondary_text_color;
        }}
      >
        Next
      </button>
    </PaymentLayout>
  );
};

export default PaymentDetail;